module.exports = __webpack_public_path__ + "img/notification.580cf5cf.svg";